import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version + 'dev',
  production: false,
  cryptoKey: 'eGJxYWNxYm14M28xY3JkaG5iNzIwd2pxNXhqeTlsZjQ=',
  apiBaseUrl: 'https://dev.api.gymki.t1.cloud.technit.solutions/api/v1/',
  storagePrefix: 'gymki_',
  storageEncryption: false,
  tokenName: 'api_token',
  center: { latitude: 47.4655126, longitude: -122.2697692 },
  googleMapsApiKey: 'AIzaSyAVtuCtKbhudm_bQNQJjFuek5oiywFrkTs',
  googleTranslateApiKey: 'AIzaSyAurXLhgrOMGKM9Qd6Nq2XLqCBjNcpTxf4',
  onesignal: {
    appId: 'd7a02f96-ee65-460e-a120-63d0da4144ae',
  },
};
